export default {
  nav: {
    home: "Home",
    engines: "Motori",
    transmissions: "Cambi",
    bodyParts: "Parti di carrozzeria",
    testimonials: "Recensioni",
    contact: "Contattaci",
    getQuote: "Richiedi un preventivo",
    menu: "Apri menu",
  },
  banner: {
    text: "GRANDI SALDI IN CORSO — Fino al 30% di SCONTO su motori, cambi e parti di carrozzeria selezionati. Spedizione disponibile in tutta l'Australia.",
  },
  hero: {
    badge: "Di fiducia dal 2005",
    title1: "Motori usati di qualità e",
    titleHighlight: "Cambi",
    desc: "{{siteName}} è il tuo punto di riferimento per ricambi usati, nuovi e aftermarket a Darwin. Specialisti dei SUV e pick-up australiani più popolari.",
    contact: "Contattaci",
    browse: "Sfoglia i motori",
  },
  about: {
    f1title: "A conduzione familiare",
    f1text: "{{siteName}} è un'attività a conduzione familiare di Darwin, fondata su fiducia, duro lavoro e genuina attenzione per ogni cliente.",
    f2title: "Reputazione",
    f2text: "Godiamo di una solida reputazione costruita su integrità, correttezza e competenza tecnica su ricambi usati, nuovi e aftermarket.",
    f3title: "Cosa facciamo",
    f3text: "Siamo il tuo punto di riferimento per ricambi usati, nuovi e aftermarket, supportati da un'officina specializzata di assistenza e riparazione.",
    f4title: "Altamente qualificati",
    f4text: "I nostri tecnici esperti utilizzano i più recenti programmi diagnostici e scanner per aiutarti a evitare costi di riparazione inutili.",
    stockLabel: "Cosa abbiamo in stock",
    modelsTitle: "Modelli popolari che copriamo",
    modelsDesc: "Ci concentriamo sui pick-up e SUV australiani più venduti, così ottieni il ricambio giusto, velocemente.",
  },
  why: {
    promise: "La nostra promessa",
    title: "Perché sceglierci",
    w1title: "Qualità",
    w1text: "La tranquillità di sapere che ti è stato fornito un ricambio e un servizio di alta qualità, ogni volta.",
    w2title: "Risparmio",
    w2text: "Tieni più soldi in tasca grazie ai nostri ottimi sconti su tutti i ricambi, nuovi e usati.",
    w3title: "Garanzia",
    w3text: "I ricambi nuovi hanno 12 mesi di garanzia, quelli usati 3 mesi di garanzia.",
    w4title: "Spedizione",
    w4text: "Gli articoli piccoli vengono spediti in giornata, quelli più grandi entro 1-3 giorni in tutta l'Australia.",
    missionTitle: "La nostra missione",
    missionText: "Fornire a te, ai nostri clienti e alla comunità, un servizio clienti di livello mondiale. Puntiamo alla massima qualità in tutto ciò che facciamo per servirti al meglio — attraverso i nostri quattro pilastri: Famiglia, Determinazione, Innovazione & Qualità.",
    valuesTitle: "I nostri valori",
    v1label: "Famiglia",
    v1text: "Siamo un'unica squadra che ha a cuore clienti, persone e fornitori.",
    v2label: "Determinazione",
    v2text: "Puntiamo al meglio in ciò che facciamo, con una vera passione per il successo.",
    v3label: "Innovazione",
    v3text: "Pensiamo fuori dagli schemi e lavoriamo sodo per migliorare continuamente.",
    v4label: "Qualità",
    v4text: "Ci impegniamo a fare le cose bene la prima volta, ogni volta.",
    t1text: "Servizio fantastico. Lavoro risolto in giornata e comunicazione costante — il tutto a un prezzo eccellente!",
    t1name: "Nico A.",
    t1loc: "Darwin",
    t2text: "Ho trovato esattamente il motore che mi serviva per il mio HiLux. Cordiali, onesti e davvero esperti di pick-up australiani. Altamente consigliati.",
    t2name: "Chris N.",
    t2loc: "Palmerston",
    t3text: "Molto disponibili, corretti e onesti, con ricambi usati di qualità per tutti i modelli più popolari. Promossi a pieni voti!",
    t3name: "Stephen C.",
    t3loc: "Darwin",
    t4text: "Sono arrivato con problemi sconosciuti e questi ragazzi mi hanno rimesso in strada rapidamente. Servizio fantastico.",
    t4name: "Armand D.",
    t4loc: "Katherine",
  },
  brand: {
    strip: "Ricambi per tutte le principali marche",
  },
  cta: {
    title: "Cerchi un ricambio?",
    desc: "Dicci cosa ti serve e il nostro team lo reperirà per te. Spediamo in tutta l'Australia dalla nostra officina di Winnellie, Darwin.",
    request: "Richiedi un preventivo",
  },
  footer: {
    brandDesc: "La fonte affidabile di Darwin per motori usati, cambi e parti di carrozzeria di qualità. A conduzione familiare e focalizzata sui pick-up e SUV australiani più popolari.",
    quickLinks: "Link rapidi",
    company: "Azienda",
    getInTouch: "Contattaci",
    monFri: "Lun - Ven: 8:00 - 17:00",
    copyright: "© Copyright {{year}} {{siteName}}. Tutti i diritti riservati.",
    disclaimer: "{{siteName}} è uno specialista indipendente di ricambi e assistenza.",
  },
  page: {
    enginesSubtitle: "Motori usati, nuovi e rigenerati di qualità per tutte le marche e modelli – europei, giapponesi e americani. Ogni motore è ispezionato, sigillato e fornito con garanzia.",
    transmissionsSubtitle: "Cambi automatici e manuali, usati e nuovi, per tutte le marche e modelli – europei, giapponesi e americani. Ogni cambio è ispezionato, testato e fornito con garanzia.",
    bodyPartsSubtitle: "Pannelli carrozzeria, paraurti, specchietti, fari e finiture, usati e aftermarket, per tutte le marche e modelli. Pannelli dritti, prezzi competitivi con garanzia.",
  },
  grid: {
    ourStock: "Il nostro stock",
    itemsInStock: "{{count}} articoli in stock",
    shipping: "Spedizione in tutta l'Australia",
    price: "Prezzo",
    enquire: "Richiedi ora",
    searchPlaceholder: "Cerca per marca, modello o nome del pezzo...",
    allMakes: "Tutte le marche",
    allModels: "Tutti i modelli",
    noResults: "Nessun pezzo corrisponde alla ricerca. Prova un'altra marca o modello.",
    clearFilters: "Cancella filtri",
  },
  availability: {
    badge: "Aggiornamento scorte",
    title: "Usato & Nuovo {{category}}",
    text: "Abbiamo motori, cambi e parti di carrozzeria per tutte le marche e modelli. Offriamo un'ampia gamma di motori, cambi e parti di carrozzeria per auto europee, giapponesi, canadesi e americane. Tutti i ricambi sono ispezionati e soddisfano i requisiti di qualità a cui sono soggetti; ogni articolo è sigillato e porta un marchio speciale. Tutti i ricambi usati hanno una garanzia di qualità a lungo termine. Se hai dubbi sulla scelta del motore, del cambio o della parte di carrozzeria, contatta il nostro team – saremo felici di rispondere alle tue domande e di darti una consulenza completa. {{siteName}} – una ricerca comoda di ricambi usati & nuovi, con consegna rapida della merce entro 1–3 giorni lavorativi dalla ricezione del pagamento.",
    cta: "Contattaci",
  },
  request: {
    badge: "Ricambio mancante?",
    title: "Non trovi il ricambio che cerchi?",
    text: "{{siteName}} reperisce ogni settimana motori, cambi e parti di carrozzeria difficili da trovare. Dicci marca, modello e anno — se oggi non è disponibile, il nostro team lo troverà per te e ti risponderà rapidamente.",
    cta: "Richiedi un ricambio",
  },
  partsWeSource: {
    badge: "Ordine speciale",
    title: "Ricambi che reperiamo",
    desc: "Non vedi ciò che cerchi? {{siteName}} reperisce ogni settimana ricambi difficili da trovare — da centraline e computer box rari a quei pezzi unici che nessun altro tiene a magazzino.",
    ecuTitle: "Centraline & unità di controllo",
    ecuText: "Moduli di controllo motore, cambio e carrozzeria, programmati e testati sul tuo veicolo.",
    computerBoxTitle: "Computer box",
    computerBoxText: "Computer box di gestione motore e moduli cablati per pick-up, SUV e altro.",
    hardToFindTitle: "Ricambi difficili da trovare",
    hardToFindText: "Finiture rare, pannelli fuori produzione e ricambi speciali reperiti tramite la nostra rete nazionale.",
    cta: "Richiedi un ricambio",
  },
  contact: {
    badge: "Mettiti in contatto",
    title: "Contattaci",
    desc: "Hai in mente un ricambio? Inviaci una richiesta e il nostro team ti risponderà tempestivamente. Spediamo in tutta l'Australia da Winnellie, Darwin NT 0820.",
    sendEnquiry: "Invia una richiesta",
    formDesc: "Compila il modulo e ti ricontatteremo a breve.",
    prefill: "Abbiamo precompilato il ricambio di cui stai chiedendo informazioni. Aggiungi solo i tuoi dati ed eventuali note qui sotto.",
    name: "Nome",
    namePlaceholder: "Il tuo nome completo",
    email: "Email",
    emailPlaceholder: "tu@email.it",
    phone: "Telefono",
    phonePlaceholder: "+61 4xx xxx xxx",
    subject: "Oggetto",
    subjectPlaceholder: "Seleziona un argomento",
    subjectEngine: "Richiesta motore",
    subjectTransmission: "Richiesta cambio",
    subjectBody: "Richiesta parte di carrozzeria",
    subjectGeneral: "Richiesta generica",
    subjectSpecialOrder: "Ordine speciale / Richiesta ricambio",
    part: "Ricambio / articolo richiesto",
    partPlaceholder: "es. Motore – Toyota HiLux 2018",
    vehicle: "Veicolo (Marca, Modello & Anno)",
    vehiclePlaceholder: "es. Toyota HiLux 2018",
    notes: "Note",
    notesPlaceholder: "Dicci quale ricambio stai cercando...",
    maxChars: "Max 500 caratteri",
    partPhoto: "Foto del ricambio (facoltativo)",
    partPhotoHint: "JPG, PNG o WebP, fino a 8 MB. Ci aiuta a identificare il ricambio esatto più rapidamente.",
    choosePhoto: "Scegli foto",
    removePhoto: "Rimuovi foto",
    photoInvalid: "Scegli un file immagine (JPG, PNG o WebP).",
    photoTooLarge: "Questa immagine è troppo grande. Scegline una sotto gli 8 MB.",
    success: "Grazie per la tua richiesta! Ti ricontatteremo a breve.",
    sending: "Invio...",
    send: "Invia richiesta",
    details: "I nostri dati",
    addressLabel: "Indirizzo",
    phoneLabel: "Telefono",
    emailLabel: "Email",
    hoursLabel: "Orari di apertura",
    sat: "Sab: Su appuntamento",
  },
  detail: {
    home: "Home",
    photos: "Foto",
    specifications: "Specifiche",
    make: "Marca",
    model: "Modello",
    year: "Anno",
    fitment: "Compatibilità",
    condition: "Condizione",
    warranty: "Garanzia",
    notFound: "Questo ricambio non è stato trovato. Potrebbe essere stato venduto o rimosso.",
    backHome: "Torna alla home",
    backToList: "Torna all'elenco",
  },
};